import '@angular/compiler';
import { PageChecklistRespondComponent } from './page.checklist.respond/page.checklist.respond.component';
import { ComponentProjectFacilitiesComponent } from './component.project.facilities/component.project.facilities.component';
import { PageUserRolesComponent } from './page.user.roles/page.user.roles.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { ComponentAuthRegisterComponent } from './component.auth.register/component.auth.register.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { ComponentProjectDrawingsComponent } from './component.project.drawings/component.project.drawings.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { ComponentProjectDocumentsComponent } from './component.project.documents/component.project.documents.component';
import { PageMainComponent } from './page.main/page.main.component';
import { ComponentProjectFacilityAddComponent } from './component.project.facility.add/component.project.facility.add.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { ComponentAuthForgotComponent } from './component.auth.forgot/component.auth.forgot.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PageProjectDetailComponent } from './page.project.detail/page.project.detail.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageChecklistEditComponent } from './page.checklist.edit/page.checklist.edit.component';
import { ComponentMainOverviewComponent } from './component.main.overview/component.main.overview.component';
import { ComponentAuthLoginComponent } from './component.auth.login/component.auth.login.component';
import { PageProjectListComponent } from './page.project.list/page.project.list.component';
import { PageChecklistListComponent } from './page.checklist.list/page.checklist.list.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { ComponentProjectDocumentAddComponent } from './component.project.document.add/component.project.document.add.component';
import { ComponentMainProjectsComponent } from './component.main.projects/component.main.projects.component';
import { ComponentMainProjectAddComponent } from './component.main.project.add/component.main.project.add.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageChecklistResultComponent } from './page.checklist.result/page.checklist.result.component';
import { ComponentProjectDrawingAddComponent } from './component.project.drawing.add/component.project.drawing.add.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PageChecklistRespondComponent,
        ComponentProjectFacilitiesComponent,
        PageUserRolesComponent,
        PortalSeasonStatusbarComponent,
        ComponentAuthRegisterComponent,
        ComponentNavComponent,
        PageLoginComponent,
        ComponentProjectDrawingsComponent,
        PortalSeasonAlertComponent,
        LayoutNavbarComponent,
        ComponentProjectDocumentsComponent,
        PageMainComponent,
        ComponentProjectFacilityAddComponent,
        PageMypageComponent,
        PortalSeasonUiDropdownComponent,
        ComponentAuthForgotComponent,
        PortalSeasonLoadingHexaComponent,
        PageProjectDetailComponent,
        LayoutAuthComponent,
        PortalSeasonLoadingSeasonComponent,
        PageChecklistEditComponent,
        ComponentMainOverviewComponent,
        ComponentAuthLoginComponent,
        PageProjectListComponent,
        PageChecklistListComponent,
        PortalSeasonLoadingComponent,
        PortalSeasonPagenationComponent,
        PortalSeasonViewerTreeComponent,
        ComponentProjectDocumentAddComponent,
        ComponentMainProjectsComponent,
        ComponentMainProjectAddComponent,
        PortalSeasonTabComponent,
        LayoutEmptyComponent,
        PageChecklistResultComponent,
        ComponentProjectDrawingAddComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }